import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withJsonpSupport,
} from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeDe from '@angular/common/locales/de';
import localeIt from '@angular/common/locales/it';
import localeJa from '@angular/common/locales/ja';
import {
  APP_ID,
  ApplicationConfig,
  ErrorHandler,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from '@angular/router';
import { environment } from 'src/environments/environment';
import { routes } from './app.routes';
import { HttpErrorInterceptor } from './shared/interceptors/http-error.interceptor';
import { QueryStateInterceptor } from './shared/interceptors/query-state.interceptor';
import { SetBearerInterceptor } from './shared/interceptors/set-bearer.interceptor';
import { CatchErrorService } from './shared/services/sys/catch-error.service';
import { SetLanguageInterceptor } from './shared/interceptors/set-language.interceptor';
import { ClearBearerInterceptor } from './shared/interceptors/clear-bearer.interceptor';
import { SetChannelInterceptor } from './shared/interceptors/set-channel.interceptor';

// Supported locales
registerLocaleData(localeEn);
registerLocaleData(localeFr);
registerLocaleData(localeEs);
registerLocaleData(localeDe);
registerLocaleData(localeIt);
registerLocaleData(localeJa);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling()
    ),
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    provideZoneChangeDetection(),
    {
      provide: ErrorHandler,
      useClass: CatchErrorService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: QueryStateInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ClearBearerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetLanguageInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetBearerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetChannelInterceptor,
      multi: true,
    },
    { provide: APP_ID, useValue: 'serverApp' },
    { provide: 'googleTagManagerId', useValue: environment.gtmId },
  ],
};
